import * as Yup from 'yup';

let AccGeneralDataSchema = Yup.object().shape({
  can_tags_map: Yup.string().required(
    'Please provide an input to the question.'
  ),
});

export default AccGeneralDataSchema;
